import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'editor/src/component/Button';

import styles from './index.module.scss';

interface Props {
  onClick?: () => void;
  disabled?: boolean;
  showLoader?: boolean;
}

function ButtonImportInDesign({ onClick, disabled, showLoader }: Props) {
  const { t } = useTranslation();

  const handleClick = () => {
    onClick?.();
  };

  return (
    <Button
      secondary
      stopPropagation
      className={cn(styles.buttonImportInDesign, 'cy-button-import-indesign')}
      disabled={disabled}
      onClick={handleClick}
      showLoader={showLoader}
    >
      {t('editor-indesign-import-button')}
    </Button>
  );
}

export default React.memo(ButtonImportInDesign);
